'use strict';
define([
    '../../../../lib/domQ'
], function (domQ) {

    function DockOverlay(overlay, target, options) {
        this.element = overlay;

        this.target = target;
        this.options = this.getOptions(options);

        this.onInitShowCallbacks = [];
        this.onShowCallbacks = [];
        this.bindEvents();
    }

    DockOverlay.SHOW_HIDE_DELAY = 100;

    DockOverlay.prototype = {

        /**
         * Show dock overlay
         */
        getOptions: function (options) {
            var defaultOptions = {
                align: 'center',
                direction: 'down',
                disableCss: 'navigation-dock-overlay--disabled',
                displayCss: 'navigation-dock-overlay--block',
                transitionCss: 'navigation-dock-overlay--transition',
                contentWrapper: '.navigation-dock-overlay__inner'
            };

            return Object.assign(defaultOptions, options);
        },

        /**
         * Executes dock overlay on show init event callbacks
         */
        bindEvents: function () {
            var dockOverlayInteractions = this.dockOverlayInteractions.bind(this),
                dockOverlayKeyInteractions = this.dockOverlayKeyInteractions.bind(this),
                dockOverlayMouseOut = this.dockOverlayMouseOut.bind(this),
                stick = this.stick.bind(this),
                hide = this.hide.bind(this);

            // add mouseover event to target element
            this.target.addEventListener('mouseover', dockOverlayInteractions);
            if (this.target.nextElementSibling) {
                if ((window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET'
                    || window.mnsInlineData.pageName === 'ORDERCONFIRM'
                    || window.mnsInlineData.pageName === 'AGEVERIFICATION'))) {
                    this.target.nextElementSibling.style.display = 'none';
                }
                else if (!window.miniBagKeyupFlag) {
                    this.target.nextElementSibling.addEventListener('click', dockOverlayKeyInteractions);
                    window.miniBagKeyupFlag = true;
                }
            }

            // add mouseout event to target element
            this.target.addEventListener('mouseout', dockOverlayMouseOut);

            // add mouseover event to ovelay element
            this.element.addEventListener('mouseover', stick);

            // add mouseout event to ovelay element
            this.element.addEventListener('mouseout', hide);
        },

        dockOverlayMouseOut: function (evt) {
            var hide = this.hide.bind(this);
            evt.stopPropagation();
            hide();
        },

        dockOverlayInteractions: function (evt) {
            var self = this,
                show = this.show.bind(this),
                stick = this.stick.bind(this);
            evt.stopPropagation();
            // execute onInitShow callbacks in asynchronous manner
            setTimeout(function () {
                self.executeOnInitShowCallbacks();
            }, 0);

            // don't show overlay if it has disable css class'
            if (domQ(self.element).hasClass(self.options.disableCss)
                || (window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET'
                    || window.mnsInlineData.pageName === 'ORDERCONFIRM'
                    || window.mnsInlineData.pageName === 'AGEVERIFICATION'
                    || (window.mnsInlineData.userLogon
                        && window.mnsInlineData.userLogon.action === 'MSCheckoutLogon')
                ))) {
                return;
            }

            show();
            stick();
        },

        dockOverlayKeyInteractions: function (evt) {
            var self = this,
                show = this.show.bind(this),
                hide = this.hide.bind(this),
                miniBagOverlayAccessibility = this.miniBagOverlayAccessibility.bind(this);
            evt.stopPropagation();
            var keyPressed = evt.key || evt.keyCode;
            if (keyPressed === 38 || keyPressed === 'ArrowUp' || keyPressed === 27 || keyPressed === 'Escape') {
                this.target.nextElementSibling.blur();
                hide();
                this.target.nextElementSibling.focus();
                window.minibagOpenFlag = 'false';
            }
            else {
                evt.stopPropagation();
                // execute onInitShow callbacks in asynchronous manner
                setTimeout(function () {
                    self.executeOnInitShowCallbacks();
                }, 0);

                // don't show overlay if it has disable css class'
                if (domQ(self.element).hasClass(self.options.disableCss)
                    || (window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET'
                        || window.mnsInlineData.pageName === 'ORDERCONFIRM'
                        || window.mnsInlineData.pageName === 'AGEVERIFICATION'
                        || (window.mnsInlineData.userLogon
                            && window.mnsInlineData.userLogon.action === 'MSCheckoutLogon')
                    ))) {
                    return;
                }
                var minibagOverlayDiv = document.getElementById('miniBagOverlayHeader');
                if (minibagOverlayDiv) {
                    if (!minibagOverlayDiv.classList.contains('navigation-dock-overlay--block')) {
                        show();
                        this.target.nextElementSibling.blur();
                        var chevronElement = this.target.nextElementSibling;
                        chevronElement.setAttribute('aria-label', 'Shopping bag Button expanded');
                        chevronElement.focus();
                        window.minibagOpenFlag = 'true';
                        setTimeout(function () {
                            miniBagOverlayAccessibility();
                        }, DockOverlay.SHOW_HIDE_DELAY * 3);
                    }
                    else if (window.minibagOpenFlag === 'true') {
                        this.target.nextElementSibling.blur();
                        hide();
                        this.target.nextElementSibling.focus();
                    }

                }


            }
        },

        /**
         * Executes dock overlay on show init event callbacks
         */
        executeOnInitShowCallbacks: function () {
            this.onInitShowCallbacks.map(function (callback) {
                callback();
            });
        },

        /**
         * Set dock overlay content
         */
        content: function (html) {
            this.element.querySelector(this.options.contentWrapper).innerHTML = html;
            var alink = document.querySelector('.navigation-res-nav-header__item.navigation-res-nav-header__item--bag a');
            if (alink && alink.querySelector(':hover')) {
                this.show();
            }
        },

        /**
         * Show dock overlay
         */
        show: function () {
            var self = this,
                innerEl = document.querySelector(self.options.contentWrapper);

            if (innerEl.firstElementChild && innerEl.firstElementChild.firstElementChild) {

                self.position();

                domQ(self.element).addClass(self.options.displayCss);
                domQ(self.element).addClass(self.options.transitionCss);


                self.executeOnShowCallbacks();
            }
        },

        /**
         * Hide dock overlay
         */
        hide: function () {
            var self = this;
            function removeAddOnTitle(removeParam) {
                if (removeParam.children.length === 2) {
                    var addOnTitle = removeParam.children[0];
                    removeParam.removeChild(addOnTitle);
                }
            }

            self.hideOverlayTimeout = setTimeout(function () {
                domQ(self.element).removeClass(self.options.transitionCss);
                domQ(self.element).removeClass(self.options.displayCss);
                self.hideOverlayTimeout = false;
                if (self.element.id === 'miniBagOverlayHeader') {
                    if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
                        var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
                        if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
                            removeAddOnTitle(removeElement.parentNode);
                        }
                        removeElement.parentNode.removeChild(removeElement);
                        var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
                        var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
                        var noOfItems = listOfItems.length + listOfAddons;
                        if (noOfItems === 2) {
                            domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
                        }
                    }
                }
            }, DockOverlay.SHOW_HIDE_DELAY);
            window.minibagOpenFlag = 'false';
            if (self.target.nextElementSibling) {
                self.target.nextElementSibling.setAttribute('aria-label', 'Shopping bag button collapsed');
            }
        },

        /* miniBagOverlayAccessibility function for minibaghide on tabing after checkout */

        miniBagOverlayAccessibility: function () {
            var self = this,
                hideoverlay = this.hideoverlay.bind(this),
                minibagfocushideOverlay = this.minibagfocushideOverlay.bind(this),
                escapeKeyTab = this.escapeKeyTab.bind(this),
                bindAtagtoTitleDiv = this.bindAtagtoTitleDiv.bind(this);
            if (self.element.id === 'miniBagOverlayHeader') {
                var focusElement = document.querySelectorAll('.nav-primary__list a'),
                    firstElement = (focusElement[0] && focusElement[0].classList.contains('nav-primary-inspire-me')) ? focusElement[1] : focusElement[0];
                firstElement.addEventListener('keyup', hideoverlay);

                self.target.addEventListener('keyup', minibagfocushideOverlay);
                var minibagContainerElement = document.querySelector('.navigation-dock-overlay__inner');
                minibagContainerElement.addEventListener('keyup', escapeKeyTab);
                var minibagTitleElements = document.querySelectorAll('.navigation-hdr-mini-bag__item-detail');
                if (minibagTitleElements) {
                    var minibagTitleElementsLength = minibagTitleElements.length;
                    for (var i = 0; i < minibagTitleElementsLength; i++) {
                        minibagTitleElements[i].addEventListener('keyup', bindAtagtoTitleDiv);
                    }
                }

            }
        },

        bindAtagtoTitleDiv: function (evt) {
            var keyPressed = evt.key || evt.keyCode;
            if (keyPressed === 'Enter' || keyPressed === 13 || keyPressed === 32 || keyPressed === '') {
                if (evt.target && evt.target.firstElementChild && evt.target.firstElementChild.href) {
                    window.location.href = evt.target.firstElementChild.href;
                }
            }
        },
        hideoverlay: function () {
            if (window.minibagOpenFlag === 'true') {
                var hide = this.hide.bind(this);
                hide();
            }
        },
        /* shift+tab to bag icon */

        minibagfocushideOverlay: function () {
            var hide = this.hide.bind(this);
            if (window.minibagOpenFlag === 'true') {
                hide();
            }
        },

        /* When User click Esc key */
        escapeKeyTab: function (evt) {
            var keyPressed = evt.key || evt.keyCode,
                self = this,
                hide = this.hide.bind(this);

            if (keyPressed === 'Escape' || keyPressed === 27) {
                hide();
                self.target.nextElementSibling.focus();
            }
        },
        /**
         * Stick dock overlay visible if overlay itself hovered
         */
        stick: function () {

            if (!this.hideOverlayTimeout) {
                return false;
            }

            clearTimeout(this.hideOverlayTimeout);
            domQ(this.element).addClass(this.options.transitionCss);

            return true;
        },

        /**
         * Position overlay by calculating top and left position
         */
        position: function () {

            // force css reading for css animation
            domQ(this.element).addClass(this.options.displayCss);

            this.element.style.top = this.calcPositionY() + 'px';
        },

        /**
         * Returns overlay calculated left position
         * @returns {Number} X position
         */
        calcPositionX: function () {
            var targetWidth = domQ(this.target).width(),
                targetOffset = domQ(this.target).offset(),
                overlayWidth = domQ(this.element).width(),
                xPos;

            switch (this.options.align.toUpperCase()) {
                case 'CENTER':
                    xPos = (targetOffset.left + targetWidth) - (overlayWidth / 2);
                    break;
                case 'RIGHT':
                    xPos = (targetOffset.left + targetWidth) - overlayWidth;
                    break;
                default:
                    xPos = targetOffset.left;
            }

            return xPos;
        },

        /**
         * Returns overlay calculated top position
         * @returns {Number} Y position
         */
        calcPositionY: function () {
            var targetHeight = domQ(this.target).height(),
                targetOffset = domQ(this.target).offset(),
                overlayHeight = domQ(this.element).height(),
                yPos;

            switch (this.options.direction.toUpperCase()) {
                case 'DOWN':
                    yPos = targetOffset.top + targetHeight;
                    break;
                default:
                    yPos = targetOffset.top - overlayHeight;
            }

            return yPos;
        },

        /**
         * Disable dock overlay by removing disable css class
         */
        enable: function () {
            domQ(this.element).removeClass(this.options.disableCss);
        },

        /**
         * Disable dock overlay by adding disable css class
         */
        disable: function () {
            domQ(this.element).addClass(this.options.disableCss);
        },

        /**
         * Executes dock overlay on show init event callbacks
         */
        executeOnShowCallbacks: function () {
            this.onShowCallbacks.map(function (callback) {
                callback();
            });
        },

        /**
         * Executes dock overlay on show init event callbacks
         */
        onInitShowEvent: function (callback) {
            var self = this;

            this.onInitShowCallbacks.push(callback);

            return function () {
                self.onInitShowCallbacks = self.onInitShowCallbacks.filter(function (item) {
                    return item !== callback;
                });
            };
        },

        /**
         * Executes dock overlay on show init event callbacks
         */
        onShowEvent: function (callback) {
            var self = this;

            this.onShowCallbacks.push(callback);

            return function () {
                self.onShowCallbacks = self.onShowCallbacks.filter(function (item) {
                    return item !== callback;
                });
            };
        }
    };

    return DockOverlay;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/dockOverlay/Index.js